import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "use",
  class: "section-container"
}
const _hoisted_2 = { class: "section-content" }

import { vReveal } from '@/directives/reveal'

export default /*@__PURE__*/_defineComponent({
  __name: 'UseLabOSSection',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "section-title" }, "Use LabOS Now", -1)),
      _cache[5] || (_cache[5] = _createElementVNode("p", { class: "section-lead" }, " Jump in: read the paper, browse code (when available), or sign up your lab to pilot LabOS. ", -1)),
      _createVNode(_component_a_row, { gutter: [18, 18] }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            xs: 24,
            sm: 24,
            md: 8,
            lg: 8
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_card, { class: "use-card" }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("h3", { class: "card-title" }, "📄 LabOS Paper", -1),
                  _createElementVNode("p", { class: "card-text" }, " Full description of the agentic AI-XR platform, the LabSuperVision benchmark, and biomedical studies. ", -1),
                  _createElementVNode("a", {
                    class: "btn btn-primary",
                    href: "https://arxiv.org/abs/2510.14861",
                    target: "_blank",
                    rel: "noopener"
                  }, " Read on arXiv ", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, {
            xs: 24,
            sm: 24,
            md: 8,
            lg: 8
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_card, { class: "use-card" }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("h3", { class: "card-title" }, "💾 LabOS Code and Hardware Kit", -1),
                  _createElementVNode("p", { class: "card-text" }, " Open-source software and hardware components. (Placeholder link — coming soon!) ", -1),
                  _createElementVNode("a", {
                    class: "btn btn-primary",
                    href: "https://forms.gle/i7cujsW9mBCpZq5m6",
                    target: "_blank",
                    rel: "noopener"
                  }, " GitHub Repository ", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, {
            xs: 24,
            sm: 24,
            md: 8,
            lg: 8
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_card, { class: "use-card" }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("h3", { class: "card-title" }, "🧪 Sign Up to Test", -1),
                  _createElementVNode("p", { class: "card-text" }, " Partner with us to deploy LabOS in your lab. Early access for research collaborators. ", -1),
                  _createElementVNode("a", {
                    class: "btn btn-primary",
                    href: "https://forms.gle/i7cujsW9mBCpZq5m6",
                    target: "_blank",
                    rel: "noopener"
                  }, " Go to Sign-up ", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_card, {
        id: "signup-form",
        class: "signup-card"
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createElementVNode("h3", { class: "signup-title" }, "Sign-up Form", -1),
          _createElementVNode("p", { class: "signup-lead" }, " Tell us about your lab and use-case. We'll follow up with access details. ", -1),
          _createElementVNode("iframe", {
            class: "google-form",
            loading: "lazy",
            src: "https://forms.gle/i7cujsW9mBCpZq5m6",
            title: "LabOS Sign-up"
          }, " Loading… ", -1),
          _createElementVNode("div", { class: "form-help" }, [
            _createTextVNode(" Having trouble? "),
            _createElementVNode("a", {
              href: "https://forms.gle/i7cujsW9mBCpZq5m6",
              target: "_blank",
              rel: "noopener"
            }, " Open the form in a new tab ↗ ")
          ], -1)
        ]))]),
        _: 1
      })
    ])), [
      [_unref(vReveal)]
    ])
  ]))
}
}

})